import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import { Box } from "@mui/material";
import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { selectWeightAndWallForm } from "../../../redux/selector";
import { actions } from "../../../redux/slice";
import { WeightAndWallFormValues } from "../../../types";
import { WEIGHT_AND_WALL_FIELDS } from "../data";
import { FormFieldControl } from "../VehicleDetails/FormControls";
import { useStyles } from "./styles";

const WeightAndWall = () => {
  const styles = useStyles();
  const dispatch = useDispatch();
  const formValues = useSelector(selectWeightAndWallForm);

  const updateField = (field: keyof WeightAndWallFormValues, value: string | boolean) => {
    dispatch(actions.updateWeightAndWallFormField({ field, value: String(value) }));
  };

  if (!formValues) {
    return null;
  }

  const fieldClassNames = {
    wrapperClassName: styles.field,
    labelClassName: styles.label,
    inputClassName: styles.input,
    selectClassName: styles.select,
    selectValueClassName: styles.selectValue,
    selectPlaceholderClassName: styles.selectPlaceholder,
    selectControlClassName: styles.selectControl,
    selectIconComponent: KeyboardArrowDownIcon,
    replaceInputStyles: true,
  };

  return (
    <Box className={styles.pageRoot}>
      <Box className={styles.grid2}>
        {WEIGHT_AND_WALL_FIELDS.map((config) => (
          <FormFieldControl
            key={String(config.field)}
            config={config}
            value={formValues[config.field]}
            onChange={(value) => updateField(config.field, value)}
            {...fieldClassNames}
          />
        ))}
      </Box>
    </Box>
  );
};

export default WeightAndWall;
